import React from 'react'

import Thumbnail from  '../thumbnail/thumbnail';

export default function OverviewThumbnails(props) {
    return (
        <React.Fragment>
            {props.data.map(({ node }) => {
                if (node.frontmatter.type === props.type) {
                    return <Thumbnail key={node.id} project={node} />
                }
                return null;
            })}
        </React.Fragment>
    )
}